import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { getProfileId } from '@/utils/profile';
import Home from '@/views/Home.vue';

export const homeRoute: RouteConfig = {
  path: '/start/:view',
  name: 'home',
  component: Home,
  meta: {
    menu: {
      title: 'menu.home',
      icon: 'fa-home',
      permissions: ['USER.EVENTS', 'USER.FEES'],
      entityType: TableName.Profile,
      entityId: getProfileId,
      params: { view: 'week' }
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    beforeCalendarRoute(to, getProfileId() as number, TableName.User, next);
  }
};
